// extracted by mini-css-extract-plugin
module.exports = {"secondary-text":"personalize-course-unit-props-helper_secondary-text__EWH8i"};